export default "__VITE_ASSET__BMb3fgSB__"